import { RequireAuth } from '@/components/shell/require-auth';
import { Outlet, createFileRoute } from '@tanstack/react-router';

// A SECOND pathless layout, sibling to `_authed` — not a child of it. The builder is full-bleed
// three-pane (p3-design-handoff.md §2) and a child route cannot opt out of its parent's chrome:
// under `_authed` it would inherit the rail, the 220px offset and the `max-w-5xl` clamp. Same auth
// guard, no shell.
export const Route = createFileRoute('/_canvas')({ component: Canvas });

function Canvas(): React.ReactNode {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
}
